module.exports = __webpack_public_path__ + "static/media/8-5.bd410e99.mp3";